import { render, staticRenderFns } from "./MyGroups.vue?vue&type=template&id=9880cdf6&"
import script from "./MyGroups.vue?vue&type=script&lang=js&"
export * from "./MyGroups.vue?vue&type=script&lang=js&"
import style0 from "../admin/minds.css?vue&type=style&index=0&lang=css&"
import style1 from "../learning.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports